import { j as e } from "../../../chunks/jsx-runtime.DGlMoOmv.js";
import { t as R } from "../../../chunks/zod.Df1jvpio.js";
import * as Y from "react";
import { useContext as ee, createContext as te, useState as P, useCallback as oe, useEffect as re } from "react";
import { useForm as I } from "react-hook-form";
import { p as N, i as se, P as ne } from "../../../chunks/PhoneNumberInputField.BHIlEyO_.js";
import { o as Z, s as k } from "../../../chunks/types.HWgrWlXv.js";
import { defineMessages as ae, useIntl as ie } from "react-intl";
import { B as x } from "../../../chunks/Button.Ccj-dDdM.js";
import { T as V } from "../../../chunks/Text.BGhoO_e3.js";
import { a as q } from "../../../chunks/Form.LdCd9gH2.js";
import { c as D } from "../../../chunks/index.CxSWpsOB.js";
import { I as le } from "../../../chunks/InputField.C5Go4vsr.js";
import { u as de } from "../../../chunks/use-media-query.CzJ6WnFm.js";
import { g as ce, j as ue, e as he, D as fe, d as me, b as pe } from "../../../chunks/Dialog.CH2ZNDp8.js";
const v = {
  Default: "default",
  Marketing: "marketing"
}, u = {
  Phone: "phone",
  Verify: "verify"
}, we = (o) => Z({
  phone: k().refine((t) => {
    if (!t)
      return !1;
    try {
      const {
        country: r
      } = N(t);
      return se(t, r);
    } catch {
      return !1;
    }
  }, {
    message: o.formatMessage({
      id: "FPcbu0",
      defaultMessage: [{
        type: 0,
        value: "Please enter a valid phone number"
      }]
    })
  }),
  phone_number: k(),
  phone_country: k(),
  phone_country_code: k()
}), ge = (o, t) => Z({
  verificationCode: k().length(t, {
    message: o.formatMessage({
      id: "VvI8Km",
      defaultMessage: [{
        type: 0,
        value: "Please enter a valid verification code"
      }]
    })
  })
}), H = (o) => {
  const t = o.slice(-4);
  return o.slice(0, -4).replace(/\d/g, "•") + t;
}, K = te({
  errorMsg: void 0,
  defaultPhoneNumber: "",
  intl: {},
  isModal: !0,
  phoneFormatted: "",
  phoneNumberForm: {},
  showSkipInsteadOfCancel: !1,
  step: u.Phone,
  variant: v.Default,
  verificationCodeLength: void 0,
  verifyPhoneNumberForm: {},
  handleOnClose: () => {
  },
  handleOnChangePhoneNumber: () => {
  },
  handleSubmitPhoneNumber: () => {
  },
  handleVerificationCodeSubmit: () => {
  },
  resendVerificationCode: () => {
  }
}), z = ({
  children: o,
  values: {
    defaultPhoneNumber: t,
    intl: r,
    isModal: n = !0,
    showSkipInsteadOfCancel: s = !1,
    startingStep: a = u.Phone,
    variant: c = v.Default,
    verificationCodeLength: i = 6,
    onClose: d,
    onSubmitPhoneNumber: l,
    onSubmitVerificationCode: g,
    resendVerificationCode: h
  }
}) => {
  const [b, M] = P(t ? a : u.Phone), C = N(t || ""), [S, L] = P(N(t || "")?.formatNational() || ""), E = C?.country, F = C?.countryCallingCode, p = I({
    resolver: R(we(r)),
    defaultValues: {
      phone: t,
      phone_country: E,
      phone_country_code: F,
      phone_number: C?.formatNational() || ""
    },
    reValidateMode: "onChange"
  }), O = async (f) => {
    p.clearErrors();
    try {
      await l(f);
    } catch {
      p.setError("root.serverError", {
        message: r.formatMessage({
          id: "8GvVWZ",
          defaultMessage: [{
            type: 0,
            value: "Something went wrong, please try again."
          }]
        })
      });
      return;
    }
    const m = N(f.phone);
    m && L(m.formatNational()), M(u.Verify);
  }, _ = () => {
    d(), w.reset(), p.reset(), y(""), M(a);
  }, w = I({
    resolver: R(ge(r, i)),
    defaultValues: {
      verificationCode: ""
    },
    reValidateMode: "onBlur"
  }), Q = () => {
    y(""), w.clearErrors(), p.clearErrors(), M(u.Phone);
  }, [X, y] = P(), J = async (f) => {
    y(""), w.clearErrors("root");
    try {
      await g(f), _();
    } catch (m) {
      if (typeof m == "object" && m !== null && "error" in m && m.error === "Phone not Updatable") {
        y(r.formatMessage({
          id: "bbMhKr",
          defaultMessage: [{
            type: 0,
            value: "You have reached the max number of times to update your phone number. You can "
          }, {
            type: 8,
            value: "atag",
            children: [{
              type: 0,
              value: "contact support"
            }]
          }, {
            type: 0,
            value: " for help."
          }]
        }, {
          atag: (W) => /* @__PURE__ */ e.jsx("a", { href: "https://support.peerspace.com/hc", className: "tw-underline", children: W })
        }));
        return;
      }
      y(r.formatMessage({
        id: "GSqy2v",
        defaultMessage: [{
          type: 0,
          value: "Verification code invalid. You have limited attempts, please confirm the number entered is correct or "
        }, {
          type: 8,
          value: "atag",
          children: [{
            type: 0,
            value: "contact support"
          }]
        }, {
          type: 0,
          value: " for help."
        }]
      }, {
        atag: (W) => /* @__PURE__ */ e.jsx("a", { href: "https://support.peerspace.com/hc", className: "tw-underline", children: W })
      }));
    }
  }, B = oe(async () => {
    w.clearErrors("root"), y("");
    try {
      await h();
    } catch (f) {
      if (typeof f == "object" && f !== null && "error" in f && f.error === "Has exceeded phone confirmation quota.") {
        y(r.formatMessage({
          id: "jhfo33",
          defaultMessage: [{
            type: 0,
            value: "You have reached the max number of times to send a code. You can "
          }, {
            type: 8,
            value: "atag",
            children: [{
              type: 0,
              value: "contact support"
            }]
          }, {
            type: 0,
            value: " for help."
          }]
        }, {
          atag: (m) => /* @__PURE__ */ e.jsx("a", { href: "https://support.peerspace.com/hc", className: "tw-underline", children: m })
        }));
        return;
      }
      w.setError("root.serverError", {
        message: r.formatMessage({
          id: "8GvVWZ",
          defaultMessage: [{
            type: 0,
            value: "Something went wrong, please try again."
          }]
        })
      });
      return;
    }
  }, [r, h, w]);
  re(() => {
    t && a === u.Verify && B();
  }, []);
  const $ = b === u.Phone ? p?.formState?.errors?.root?.serverError?.message || "" : w?.formState?.errors?.root?.serverError?.message || X;
  return /* @__PURE__ */ e.jsx(K.Provider, { value: {
    errorMsg: $,
    defaultPhoneNumber: t,
    intl: r,
    isModal: n,
    phoneFormatted: S,
    phoneNumberForm: p,
    showSkipInsteadOfCancel: s,
    step: b,
    variant: c,
    verificationCodeLength: i,
    verifyPhoneNumberForm: w,
    handleOnClose: _,
    handleOnChangePhoneNumber: Q,
    handleSubmitPhoneNumber: O,
    handleVerificationCodeSubmit: J,
    resendVerificationCode: B
  }, children: o });
}, j = () => {
  const o = ee(K);
  if (o === void 0)
    throw new Error("usePhoneVerificationContextData must be used within a PhoneVerificationProvider");
  return o;
}, T = ae({
  default_phone_title: {
    id: "jdJhOL",
    defaultMessage: [{
      type: 0,
      value: "Phone number"
    }]
  },
  default_phone_subtitle: {
    id: "I7mtKl",
    defaultMessage: [{
      type: 0,
      value: "Only used for booking updates."
    }]
  },
  default_verify_title: {
    id: "NSyuEP",
    defaultMessage: [{
      type: 0,
      value: "Enter verification code"
    }]
  },
  default_verify_subtitle: {
    id: "IKcjYb",
    defaultMessage: [{
      type: 0,
      value: "Enter the "
    }, {
      type: 1,
      value: "verificationCodeLength"
    }, {
      type: 0,
      value: "-digit code we sent to "
    }, {
      type: 1,
      value: "phone_number"
    }, {
      type: 0,
      value: " below. "
    }, {
      type: 8,
      value: "button",
      children: [{
        type: 0,
        value: "Change phone number"
      }]
    }]
  },
  marketing_phone_title_phone_unknown: {
    id: "pWWzFs",
    defaultMessage: [{
      type: 0,
      value: "Never miss a booking update"
    }]
  },
  marketing_phone_title_phone_known: {
    id: "QofabW",
    defaultMessage: [{
      type: 0,
      value: "Verify your phone number"
    }]
  },
  marketing_phone_subtitle: {
    id: "RYTU9p",
    defaultMessage: [{
      type: 0,
      value: "For better security and seamless communication with guests, phone number verification is required."
    }]
  }
}), ye = (o, t) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: t, ...o, children: /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "m13.37 6.338 1.05-1.05a1.75 1.75 0 0 0 0-2.475L13.188 1.58a1.75 1.75 0 0 0-2.475 0L2.657 9.636a.5.5 0 0 0-.152.29l-.518 3.52a.5.5 0 0 0 .567.568l3.498-.516a.5.5 0 0 0 .302-.144l6.984-6.984a.484.484 0 0 0 .031-.032Zm-.89-4.05 1.233 1.232a.75.75 0 0 1 0 1.06L13 5.293 10.707 3l.713-.712a.75.75 0 0 1 1.06 0ZM12.293 6l-6.126 6.125-2.293-2.293L10 3.707l2.293 2.294Zm-9.219 6.925.318-2.16 1.842 1.842-2.16.318Z" }) }), xe = Y.forwardRef(ye), A = () => {
  const {
    errorMsg: o,
    variant: t
  } = j();
  return /* @__PURE__ */ e.jsx(V, { className: D("tw-inline-block tw-text-center tw-text-red-800 tw-my-8 tw-body-1", {
    "tw-text-center": t === v.Marketing
  }), children: o });
}, ve = () => {
  const {
    intl: o,
    variant: t,
    phoneNumberForm: r,
    phoneFormatted: n,
    showSkipInsteadOfCancel: s,
    handleOnClose: a,
    handleSubmitPhoneNumber: c
  } = j(), [i, d] = P(!n), l = () => d(!0);
  return /* @__PURE__ */ e.jsxs(q, { className: "tw-w-full tw-h-full tw-flex tw-flex-col", ...r, onSubmit: r.handleSubmit(c), spacing: 0, children: [
    i ? /* @__PURE__ */ e.jsx(ne, { name: "phone", fullWidth: !0 }) : /* @__PURE__ */ e.jsx(V, { className: "tw-w-full tw-justify-center", typeface: "body-4", suffix: /* @__PURE__ */ e.jsx(x, { variant: "ghost", iconOnly: !0, onClick: l, children: /* @__PURE__ */ e.jsx(xe, {}) }), children: H(n || "") }),
    /* @__PURE__ */ e.jsx(V, { typeface: "body-1-long", className: D("tw-text-gray-600 tw-mt-8 tw-w-full", {
      "tw-flex tw-justify-center": !i
    }), children: o.formatMessage({
      id: "y+1dH+",
      defaultMessage: [{
        type: 0,
        value: "We’ll text you a code to verify your number. Standard message and data rates may apply."
      }]
    }) }),
    /* @__PURE__ */ e.jsx(A, {}),
    /* @__PURE__ */ e.jsxs("div", { className: "ps-row tw-justify-between tw-pt-24", children: [
      /* @__PURE__ */ e.jsx(x, { variant: s ? "outline-1" : "underline-m", className: "xs:tw-hidden sm:tw-flex", onClick: a, "data-testing-id": "verifyPhoneSkipOrCancelButton", children: s ? o.formatMessage({
        id: "/4tOwT",
        defaultMessage: [{
          type: 0,
          value: "Skip"
        }]
      }) : t === v.Marketing ? o.formatMessage({
        id: "S40Ltd",
        defaultMessage: [{
          type: 0,
          value: "Skip, I'll do this later"
        }]
      }) : o.formatMessage({
        id: "47FYwb",
        defaultMessage: [{
          type: 0,
          value: "Cancel"
        }]
      }) }),
      /* @__PURE__ */ e.jsx(x, { type: "submit", showSpinner: r.formState.isSubmitting, className: "tw-w-full sm:tw-w-auto", "data-testing-id": "verifyPhoneSubmitButton", children: t === v.Marketing ? o.formatMessage({
        id: "cnahaB",
        defaultMessage: [{
          type: 0,
          value: "Verify number"
        }]
      }) : o.formatMessage({
        id: "MTwUmz",
        defaultMessage: [{
          type: 0,
          value: "Send code"
        }]
      }) })
    ] })
  ] });
}, be = () => {
  const [o, t] = P(!1), r = de("(max-width: 576px)", {
    isActive: !0
  }), {
    intl: n,
    isModal: s,
    verifyPhoneNumberForm: a,
    verificationCodeLength: c,
    handleOnClose: i,
    handleVerificationCodeSubmit: d,
    resendVerificationCode: l
  } = j(), {
    formState: {
      isSubmitting: g
    }
  } = a, h = async (b) => {
    b.preventDefault(), t(!0), a.resetField("verificationCode");
    try {
      await l();
    } catch {
      a.setError("root.serverError", {
        message: n.formatMessage({
          id: "AsX3qN",
          defaultMessage: [{
            type: 0,
            value: "Verification failed. Please try again."
          }]
        })
      });
    } finally {
      t(!1);
    }
  };
  return /* @__PURE__ */ e.jsxs(q, { className: "tw-flex tw-flex-col tw-w-full tw-h-full", ...a, onSubmit: a.handleSubmit(d), spacing: 0, children: [
    /* @__PURE__ */ e.jsx(le, { name: "verificationCode", placeholder: n.formatMessage({
      id: "/6gLBc",
      defaultMessage: [{
        type: 0,
        value: "Verification code"
      }]
    }), type: "text", maxLength: c, fullWidth: !0 }),
    /* @__PURE__ */ e.jsx(A, {}),
    /* @__PURE__ */ e.jsx("div", { className: "tw-flex xs:tw-flex-col sm:tw-flex-row tw-justify-between tw-h-full tw-w-full tw-pt-16", children: /* @__PURE__ */ e.jsxs("div", { className: "tw-w-full xs:tw-h-full sm:tw-h-auto tw-flex xs:tw-flex-col sm:tw-flex-row tw-justify-between sm:tw-self-end sm:tw-items-center xs:tw-gap-12 sm:tw-gap-0", children: [
      !s && /* @__PURE__ */ e.jsx(x, { variant: "underline-m", onClick: h, disabled: o, className: "xs:tw-justify-start sm:tw-items-center", "data-testing-id": "verifyPhoneResendCodeButton", children: n.formatMessage({
        id: "IdxmOT",
        defaultMessage: [{
          type: 0,
          value: "Resend Code"
        }]
      }) }),
      /* @__PURE__ */ e.jsxs("div", { className: D("tw-flex xs:tw-flex-col sm:tw-flex-row tw-w-full sm:tw-w-auto xs:tw-justify-end sm:tw-justify-between tw-gap-24 sm:tw-gap-0", {
        "sm:tw-w-full": r || s
      }), children: [
        /* @__PURE__ */ e.jsx(x, { onClick: s ? h : i, appearance: r || s ? "black" : "white", disabled: o, variant: r || s ? "underline-m" : "outline-1", className: "tw-w-full sm:tw-w-auto sm:tw-mr-12 tw-order-2 sm:tw-order-1", "data-testing-id": s ? "verifyPhoneResendCodeButton" : "verifyPhoneSkipButton", children: s ? n.formatMessage({
          id: "IdxmOT",
          defaultMessage: [{
            type: 0,
            value: "Resend Code"
          }]
        }) : n.formatMessage({
          id: "/4tOwT",
          defaultMessage: [{
            type: 0,
            value: "Skip"
          }]
        }) }),
        /* @__PURE__ */ e.jsx(x, { type: "submit", showSpinner: g, className: "tw-w-full sm:tw-w-auto tw-order-1 sm:tw-order-2", "data-testing-id": "verifyPhoneVerifySubmitButton", children: n.formatMessage({
          id: "q5Xl0M",
          defaultMessage: [{
            type: 0,
            value: "Verify"
          }]
        }) })
      ] })
    ] }) })
  ] });
}, G = () => {
  const {
    step: o
  } = j();
  return o === u.Phone ? /* @__PURE__ */ e.jsx(ve, {}) : /* @__PURE__ */ e.jsx(be, {});
}, je = (o, t) => /* @__PURE__ */ e.jsxs("svg", { width: 72, height: 72, viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: t, ...o, children: [
  /* @__PURE__ */ e.jsxs("g", { clipPath: "url(#clip0_1441_27179)", children: [
    /* @__PURE__ */ e.jsx("rect", { width: 72, height: 72, fill: "white" }),
    /* @__PURE__ */ e.jsx("path", { d: "M10.4316 43.873L10.3274 44.0455C8.46976 47.1174 9.45411 51.1135 12.526 52.9711L12.6984 53.0754", stroke: "#8559EC", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("path", { d: "M4.10938 43.5049V43.5049C1.46409 48.353 3.27071 54.4986 8.11883 57.1439V57.1439", stroke: "#8559EC", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("path", { d: "M58.9121 24.7383L59.0886 24.8357C62.2315 26.5702 63.3732 30.5243 61.6387 33.6672L61.5413 33.8437", stroke: "#8559EC", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("path", { d: "M64.207 20.873V20.873C68.9192 23.7536 70.4213 29.9806 67.5407 34.6927V34.6927", stroke: "#8559EC", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("rect", { x: 18, y: 10, width: 32, height: 56, rx: 3, transform: "rotate(-5 18 10)", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("path", { d: "M35.5 60.8643L41.4772 60.3413", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("rect", { x: 30.3359, y: 13.3135, width: 8, height: 1, rx: 0.5, transform: "rotate(-5 30.3359 13.3135)", fill: "currentColor", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("path", { d: "M29.362 36.6111C29.0251 32.7598 31.874 29.3645 35.7253 29.0276V29.0276C39.5766 28.6907 42.9718 31.5396 43.3088 35.3909L44.0932 44.3566L30.1464 45.5768L29.362 36.6111Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("path", { d: "M28.1543 45.751L46.0858 44.1822", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ e.jsx("path", { d: "M35.5078 26.5371L35.7257 29.0276", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })
  ] }),
  /* @__PURE__ */ e.jsx("defs", { children: /* @__PURE__ */ e.jsx("clipPath", { id: "clip0_1441_27179", children: /* @__PURE__ */ e.jsx("rect", { width: 72, height: 72, fill: "white" }) }) })
] }), Me = Y.forwardRef(je), U = () => {
  const {
    intl: o,
    isModal: t,
    step: r,
    variant: n,
    phoneFormatted: s,
    verificationCodeLength: a,
    handleOnChangePhoneNumber: c
  } = j(), i = r === u.Phone, d = r === u.Verify, l = n === v.Marketing, g = i && l, h = i && !l, b = t ? ce : "div", M = t ? {
    headerAlignment: i && l ? "center" : "left",
    showCloseButton: !0
  } : {
    className: "tw-flex tw-flex-col"
  }, C = t ? ue : V, S = t ? {} : {
    typeface: "headline-3-b",
    className: "tw-text-gray-900"
  }, L = t ? he : V, E = t ? {} : {
    typeface: "body-1",
    className: "tw-mb-16 tw-text-gray-600"
  }, F = d ? "default_verify_title" : h ? "default_phone_title" : s ? "marketing_phone_title_phone_known" : "marketing_phone_title_phone_unknown", p = d ? "default_verify_subtitle" : l ? "marketing_phone_subtitle" : "default_phone_subtitle", O = d ? {
    verificationCodeLength: a,
    phone_number: H(s),
    button: (_) => /* @__PURE__ */ e.jsx(x, { variant: "underline", onClick: c, children: _ })
  } : {};
  return /* @__PURE__ */ e.jsxs(b, { ...M, children: [
    /* @__PURE__ */ e.jsxs(C, { ...S, children: [
      g && /* @__PURE__ */ e.jsx(Me, { className: "tw-mb-32 tw-w-full" }),
      o.formatMessage(T[F])
    ] }),
    /* @__PURE__ */ e.jsx(L, { ...E, children: o.formatMessage(T[p], {
      ...O
    }) })
  ] });
}, Ie = ({
  defaultPhoneNumber: o = "",
  intl: t,
  open: r,
  showSkipInsteadOfCancel: n,
  startingStep: s,
  variant: a = v.Default,
  verificationCodeLength: c,
  onSubmitPhoneNumber: i,
  onSubmitVerificationCode: d,
  resendVerificationCode: l,
  setOpen: g
}) => {
  const h = () => g(!1);
  return /* @__PURE__ */ e.jsx(z, { values: {
    defaultPhoneNumber: o,
    isModal: !0,
    intl: t,
    showSkipInsteadOfCancel: n,
    startingStep: s,
    variant: a,
    verificationCodeLength: c,
    onClose: h,
    onSubmitPhoneNumber: i,
    onSubmitVerificationCode: d,
    resendVerificationCode: l
  }, children: /* @__PURE__ */ e.jsx(Ce, { open: r }) });
}, Ce = ({
  open: o
}) => {
  const {
    handleOnClose: t
  } = j();
  return /* @__PURE__ */ e.jsx(fe, { open: o, onOpenChange: t, children: /* @__PURE__ */ e.jsxs(me, { size: "md", children: [
    /* @__PURE__ */ e.jsx(U, {}),
    /* @__PURE__ */ e.jsx(pe, { showScrollBorder: !0, className: "tw-pb-24", children: /* @__PURE__ */ e.jsx(G, {}) })
  ] }) });
}, Te = ({
  defaultPhoneNumber: o,
  showSkipInsteadOfCancel: t,
  startingStep: r,
  variant: n,
  verificationCodeLength: s,
  onClose: a,
  onSubmitPhoneNumber: c,
  onSubmitVerificationCode: i,
  resendVerificationCode: d
}) => {
  const l = ie();
  return /* @__PURE__ */ e.jsx(z, { values: {
    defaultPhoneNumber: o,
    showSkipInsteadOfCancel: t,
    intl: l,
    isModal: !1,
    startingStep: r,
    variant: n,
    verificationCodeLength: s,
    onClose: a,
    onSubmitPhoneNumber: c,
    onSubmitVerificationCode: i,
    resendVerificationCode: d
  }, children: /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-flex-col tw-w-full tw-h-full", children: [
    /* @__PURE__ */ e.jsx(U, {}),
    /* @__PURE__ */ e.jsx(G, {})
  ] }) });
};
export {
  ve as PhoneNumberForm,
  Te as PhoneVerification,
  A as PhoneVerificationErrorMsg,
  G as PhoneVerificationFormSwitch,
  U as PhoneVerificationHeader,
  Ie as PhoneVerificationModal,
  z as PhoneVerificationProvider,
  be as VerificationCodeForm,
  we as getPhoneNumberFormSchema,
  ge as getVerifyPhoneNumberFormSchema,
  H as phoneNumberRedaction,
  T as phoneVerificationMessages,
  j as usePhoneVerificationContextData
};
//# sourceMappingURL=index.js.map
